import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

type AutoCompleteProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    props?: any
    children?: React.ReactNode
}

export const AutoCompleteContainer = memo(({templating, children, props}: AutoCompleteProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props}>{children}</ComponentName>
        </Suspense>
    )
})
AutoCompleteContainer.displayName = "AutoCompleteContainer"

export default connect(AutoCompleteContainer)
